var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"legal-card",on:{"click":_vm.goToLegalPage}},[_c('div',{staticClass:"legal-card__title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"legal-card__link"},[_vm._v(" Vezi pagina ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }